export default "__VITE_ASSET__rZdqvfR9__";